/* eslint-disable react/require-default-props */
import React from 'react';
import { AdditionalStyles } from 'types/common/AdditionalStyles';

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'>, AdditionalStyles {
  text: string;
  iconSrc?: string;
  iconAlt?: string;
  addIconPadding?: boolean;
}

export default function Badge({ text, styles, iconSrc, iconAlt, addIconPadding, ...restProps }: Props) {
  return (
    <div
      className={`flex w-fit bg-slate-700  rounded-lg leading-[1.5] text-xs px-2 py-[0.125rem] sm:text-md sm:px-4 sm:py-1 ${styles}`}
      {...restProps}>
      <div className="flex gap-1 items-center">
        {iconSrc && (
          <img
            className={`h-4 w-4 sm:h-7 sm:w-7 ${addIconPadding ? `p-[0.125rem]` : ''}`}
            src={iconSrc}
            alt={iconAlt}
          />
        )}
        <div className="text-xs">{text}</div>
      </div>
    </div>
  );
}
